import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from 'moment';

import { ProdutoService } from '../services/produto.service';
import { FornecedorService } from '../services/fornecedor.service';
import { GrupoProdutoService } from '../services/grupo-produto.service';
import { ExcelService } from '../services/excel.service';
import Swal from 'sweetalert2';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-estoque',
  templateUrl: './estoque.component.html',
  styleUrls: ['./estoque.component.css'],
	animations: [loadingFade, modal, alert]
})
export class EstoqueComponent implements OnInit {

	public menu_id = 157;

  public loading = false;

  // paginacao
	public page = 1;
	public limit = 10;
	public count = 0;
	
	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public filtered = false;
	public formFiltro: FormGroup;
	public showFilter = true;
	public fornecedores;
	public gruposProduto;
	public produtos;

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;		


	constructor(private fb: FormBuilder,
							private produtoSvc: ProdutoService,
							private fornecedorSvc: FornecedorService,
							private grupoProdutoSvc: GrupoProdutoService,
							private router: Router,	
							private route: ActivatedRoute,	
							private excelSvc: ExcelService,
							private perfilUsuarioSvc: PerfilUsuarioService,
							private authSvc: AuthService,
							) { }

  ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  	

		this.pegaFornecedores();
		this.pegaGruposProduto();
		this.pegaProdutos();
		this.criaFiltro();
	}
	
	criaFiltro() {
		this.formFiltro = this.fb.group({
			produto_codigo___produto_codigo: '',
			produto_descricao___produto_descricao: '',
			fornecedor_id___fornecedor_id: null,
			grupo_produto_id___grupo_produto_id: null,
			produto_valor___valorMin: '',
			produto_valor___valorMax: '',
			produto_qtd___produto_qtd: ''
		});


		this.route.params.subscribe( params => {

			if(params.id){
	  
			  let splitF = params.id.split("&");
	  
			  let loProdutoCodigo = null;
			  let loDescricao = null;
			  let loFornecedor = null;
			  let loGrupoId = null;
			  let loValorMin = null;
			  let loValorMax = null;
			  let loQtd = null;
	  
			  //this.showFilter = false;
	  
			  for (var i = 0; i < splitF.length; i++) {
	  
				var loSplitValor = splitF[i].split("=");
	  
				switch(loSplitValor[0]) { 
				  case "produto_codigo___produto_codigo": { 
	  
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					  loProdutoCodigo = loSplitValor[1];
					}
					 break; 
	  
				  } 
				  case "produto_descricao___produto_descricao": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					  loDescricao = loSplitValor[1];
					}
	  
					break; 
				  }
				  case "fornecedor_id___fornecedor_id": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					loFornecedor = parseInt(loSplitValor[1]);
					}
			
					break; 
				  }   
				  case "grupo_produto_id___grupo_produto_id": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					loGrupoId = parseInt(loSplitValor[1]);
					}
			
					break; 
				  }  	
				  case "produto_valor___valorMin": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					loValorMin = loSplitValor[1];
					}
			
					break; 
				  }  	
				  case "produto_valor___valorMax": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					loValorMax = loSplitValor[1];
					}
			
					break; 
				  }  
				  case "produto_qtd___produto_qtd": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					loQtd = loSplitValor[1];
					}
			
					break; 
				  }  				  
			  }
			}

			this.preencheForm({
				produto_codigo___produto_codigo: loProdutoCodigo,
				produto_descricao___produto_descricao: loDescricao,
				fornecedor_id___fornecedor_id: loFornecedor,
				grupo_produto_id___grupo_produto_id: loGrupoId,
				produto_valor___valorMin: loValorMin,
				produto_valor___valorMax: loValorMax,
				produto_qtd___produto_qtd: loQtd
			});
			  this.filtra();
	  
			}
	  
		  });	  

	}

	preencheForm(dados) {
		this.formFiltro.setValue(dados);
	}

	pegaFornecedores(){
    this.fornecedorSvc.getFornecedores().then((data: any) => {
      this.fornecedores = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaGruposProduto(){
    this.grupoProdutoSvc.getGruposProduto().then((data: any) => {
      this.gruposProduto = data;
    }).catch((err) => {
      console.log(err);
    });
	}
	
	pegaProdutos(){
		this.loading = true;
		this.produtoSvc.getProdutos().then((data: any) => {
			this.produtos = data;
			this.count = this.produtos.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	filtra() {
		this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroPipe().transform(this.produtos, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.filtered = true;
		this.page = 1;
	}


  expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaProduto(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.produtoSvc.apagaProduto(id).then((data) => {
					this.pegaProdutos();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	exportarExcel(){
		let data = [];
		if(this.dadosFiltrados.length == 0){
			this.dadosFiltrados = this.produtos;
		}
		for(let index in this.dadosFiltrados){
			data[index] = {
				'Cód.' : this.dadosFiltrados[index].produto_codigo,
				'Descrição' : this.dadosFiltrados[index].produto_descricao,
				'Lote' : this.dadosFiltrados[index].grupo_produto.grupo_produto_lote_nome,
				'Validade Lote' : moment(this.dadosFiltrados[index].grupo_produto.grupo_produto_data_validade).format('DD/MM/YYYY'),
				'Fornecedor' : this.dadosFiltrados[index].fornecedor.fornecedor_nome,
				'Localização' : this.dadosFiltrados[index].produto_localizacao,
				'Mín.' : this.dadosFiltrados[index].produto_qtd_min + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Entr.' : this.dadosFiltrados[index].qtd_entradas + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Saída' : this.dadosFiltrados[index].qtd_saidas + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Saldo' :this.dadosFiltrados[index].produto_qtd_saldo + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Status' : this.dadosFiltrados[index].produto_nivel,
				'Compra' : String(this.dadosFiltrados[index].total_entradas).replace('.', ','),
				'Valor Total' : String(this.dadosFiltrados[index].total_saidas).replace('.', ',')			};
			//Removido
			/*

				'Cód.' : this.dadosFiltrados[index].produto_codigo,
				'Descrição' : this.dadosFiltrados[index].produto_descricao,
				'Fornecedor' : this.dadosFiltrados[index].fornecedor.fornecedor_nome,
				'Grupo' : this.dadosFiltrados[index].grupo_produto.grupo_produto_nome,
				'Localização' : this.dadosFiltrados[index].produto_localizacao,
				'Mín.' : this.dadosFiltrados[index].produto_qtd_min + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Entr.' : this.dadosFiltrados[index].qtd_entradas + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Saída' : this.dadosFiltrados[index].qtd_saidas + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Qtde.' : this.dadosFiltrados[index].produto_qtd_saldo + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Nível' : this.dadosFiltrados[index].produto_nivel,
				'Compra' : String(this.dadosFiltrados[index].total_entradas).replace('.', ','),
				'Venda' : String(this.dadosFiltrados[index].total_saidas).replace('.', ','),
				'Lucro' : this.dadosFiltrados[index].produto_lucro + '%',
				'Saldo' : String(this.dadosFiltrados[index].produto_valor_saldo).replace('.', ',')			
			
			*/


		}
		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Produtos');
	}
	EditEstoque(produto_id){

		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		//Envia dados
		this.router.navigate(['home/estoque/edit/' + produto_id + params] );
	}

	VerEstoque(produto_id){
		this.router.navigate(['home/estoque/ver/' + produto_id] );
	}

    onClickLimparCampos(){
		this.formFiltro = this.fb.group({
			produto_codigo___produto_codigo: '',
			produto_descricao___produto_descricao: '',
			fornecedor_id___fornecedor_id: null,
			grupo_produto_id___grupo_produto_id: null,
			produto_valor___valorMin: '',
			produto_valor___valorMax: '',
			produto_qtd___produto_qtd: ''
		});

    }

}






